import { ReactNode } from 'react';

type TabPanelProps = {
  children: ReactNode;
  index: number;
  activeTabIndex: number;
};

export const TabPanel = ({
  children,
  index,
  activeTabIndex,
}: TabPanelProps) => {
  const shouldDisplayTabPanel = activeTabIndex === index;

  if (!shouldDisplayTabPanel) return null;

  return <div role="tabpanel">{children}</div>;
};
